import React from 'react'
import styles from './CommentThread.module.sass'
import Icon from '@jimmyboys/liita-ui/dist/components/Icon'
import { useGlobal } from '@jimmyboys/liita-ui/dist/components/GlobalContext'
import { LinkedElementType } from 'utils/enums'

const CommentLinkedElement = ({ linkedTo, processId }) => {
	const { gotoAppointment, gotoRequisition, i18n } = useGlobal()

	return linkedTo ? (
		<small
			className={`${styles['selected-comment-linked-element']} ${styles['--linked']}`}
			onClick={() => {
				if (linkedTo.type === LinkedElementType.Appointment) {
					return gotoAppointment(processId, linkedTo.id)
				}
				return gotoRequisition(processId, linkedTo.id)
			}}
		>
			<Icon
				name='chain'
				width='20px'
				height='20px'
				className={styles['--linked']}
			/>{' '}
			{linkedTo.text} #{linkedTo.id}
		</small>
	) : (
		<small className={styles['selected-comment-linked-element']}>
			<Icon name='chain' width='20px' height='20px' />{' '}
			{i18n`Without linked element`}
		</small>
	)
}

export default CommentLinkedElement
